import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { MuiTimePicker } from "../framework/muiTimePicker";
import {
    Checkbox,
    Typography,
    Tooltip,
    IconButton,
    Alert,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { CalcGeneralProps } from "./CalculationMain";
import { NumberInput } from "../framework/numberInput";

export const CalcOtherAdditions = ({
    translate,
    handleChange,
    settings,
}: CalcGeneralProps) => {
    const {
        dayWorkStartTime,
        eveningWorkStartTime,
        nightWorkStartTime,
        isEveningCalculationOn,
        isNightCalculationOn,
        isSundayOrHolidaySpecificEveningCalculationOn,
        isSundayOrHolidaySpecificNightCalculationOn,
        isEveningAndNightAdditionThresholdOn,
        eveningAndNightAdditionThreshold,
        isFixedAdditionOn,
        isVehicleGroupAdditionOn,
    } = settings || {};

    const isAnyEveningOrNightOn =
        isEveningCalculationOn ||
        isNightCalculationOn ||
        isSundayOrHolidaySpecificEveningCalculationOn ||
        isSundayOrHolidaySpecificNightCalculationOn;

    return (
        <Grid2 container direction="column" spacing={2} p={3}>
            <Grid2>
                <Typography variant="h3">
                    {translate("otherAdditions")}
                </Typography>
            </Grid2>
            <Grid2>
                <label className={"field-width-normal"}>
                    <Checkbox
                        id="FIXEDADDITIONON"
                        checked={isFixedAdditionOn}
                        onChange={(event) =>
                            handleChange(
                                "isFixedAdditionOn",
                                event.target.checked
                            )
                        }
                    />
                    {translate("fixedAddition")}
                    <Tooltip title={translate("fixedAdditionHelp")}>
                        <IconButton disableRipple>
                            <InfoIcon color="primary" />
                        </IconButton>
                    </Tooltip>
                </label>
            </Grid2>
            <Grid2>
                <label className={"field-width-normal"}>
                    <Checkbox
                        id="VEHICLEGROUPADDITION"
                        checked={isVehicleGroupAdditionOn}
                        onChange={(event) =>
                            handleChange(
                                "isVehicleGroupAdditionOn",
                                event.target.checked
                            )
                        }
                    />
                    {translate("fleetGroupAddition")}
                </label>
            </Grid2>
            <Grid2>
                <label className={"field-width-normal"}>
                    <Checkbox
                        id="EVENINGCALCULATIONON"
                        checked={isEveningCalculationOn}
                        onChange={(event) =>
                            handleChange(
                                "isEveningCalculationOn",
                                event.target.checked
                            )
                        }
                    />
                    {translate("EVENINGCALCULATIONON")}
                </label>
            </Grid2>
            <Grid2 mb={1}>
                <label className={"field-width-normal"}>
                    <Checkbox
                        id="NIGHTCALCULATIONISON"
                        checked={isNightCalculationOn}
                        onChange={(event) =>
                            handleChange(
                                "isNightCalculationOn",
                                event.target.checked
                            )
                        }
                    />
                    {translate("NIGHTCALCULATIONISON")}
                </label>
            </Grid2>
            {isEveningCalculationOn ? (
                <Grid2>
                    <MuiTimePicker
                        label={translate("EVENINGWORKSTARTTIME")}
                        value={eveningWorkStartTime}
                        onChange={(newValue) =>
                            handleChange("eveningWorkStartTime", newValue)
                        }
                    />
                </Grid2>
            ) : null}
            {isEveningCalculationOn || isNightCalculationOn ? (
                <Grid2>
                    <MuiTimePicker
                        label={[
                            isEveningCalculationOn
                                ? translate("EVENINGWORKENDTIME")
                                : null,
                            isNightCalculationOn
                                ? translate("NIGHTWORKSTARTTIME")
                                : null,
                        ]
                            .filter(Boolean)
                            .join(" / ")}
                        value={nightWorkStartTime}
                        onChange={(newValue) =>
                            handleChange("nightWorkStartTime", newValue)
                        }
                    />
                </Grid2>
            ) : null}
            {isNightCalculationOn ? (
                <Grid2>
                    <MuiTimePicker
                        label={translate("DAYWORKSTARTTIME")}
                        value={dayWorkStartTime}
                        onChange={(newValue) =>
                            handleChange("dayWorkStartTime", newValue)
                        }
                    />
                </Grid2>
            ) : null}
            {isAnyEveningOrNightOn ? (
                <Grid2 container className="field-width-normal">
                    <Grid2 container alignItems="center">
                        <Grid2 xs={2}>
                            <Checkbox
                                id="isEveningAndNightAdditionThresholdOn"
                                checked={isEveningAndNightAdditionThresholdOn}
                                onClick={() =>
                                    handleChange(
                                        "isEveningAndNightAdditionThresholdOn",
                                        !isEveningAndNightAdditionThresholdOn
                                    )
                                }
                            />
                        </Grid2>
                        <Grid2 xs={10}>
                            <NumberInput
                                label={translate("eveningAndNightThreshold")}
                                onChange={(val) =>
                                    handleChange(
                                        "eveningAndNightAdditionThreshold",
                                        val
                                    )
                                }
                                value={eveningAndNightAdditionThreshold}
                                endAdornment="h"
                                disabled={!isEveningAndNightAdditionThresholdOn}
                            />
                        </Grid2>
                    </Grid2>
                    <Grid2>
                        <Alert severity="info" className="field-width-normal">
                            {translate("eveningAndNightThresholdDescription")}
                        </Alert>
                    </Grid2>
                </Grid2>
            ) : null}
        </Grid2>
    );
};
